import { formatProducts } from "../utils/functions";

const pageProductCorrelati = () => {
  setInterval(() => {
    const correlati = document.querySelectorAll(".related-product__content .product-list__item");
    let check = false;
    if (correlati) {
      correlati.forEach((corr) => {
        if (corr.classList.contains("correlati-check")) {
          check = true;
        }
      });

      if (!check) {
        formatProducts(correlati);
        correlati.forEach((corr) => {
          corr.classList.add("correlati-check");
        });
      }
    }
  }, 100);
};

export default pageProductCorrelati;
